import React, { useState } from "react";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  injectStripe,
} from "react-stripe-elements";

import { AddressHelper } from "../../helpers";
import { AddressForm } from "../../forms";
import { SubmitButton } from "../../components";

const style = {
  base: {
    fontFamily: "sans-serif",
    fontSize: "16px",
    textAlign: "center",
    backgroundColor: "#F6F6F6",
    color: "#2F2F2F",
    lineHeight: "56px",
  },
};

const CardForm = ({ shippingAddress, processPayment, ...props }) => {
  const [errors, setErrors] = useState({});
  const [validElements, setValidElements] = useState({});

  const [emptyElements, setEmptyElements] = useState({
    number: true,
    expiry: true,
    cvc: true,
  });

  const [sameAddress, setSameAddress] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const setElementError = (element, error) => {
    errors[element] = error;
    setErrors({ ...errors });
  };

  const onElementChange = (name, e) => {
    const { error, complete, empty } = e;

    setElementError(name, error?.message);

    validElements[name] = complete;
    setValidElements({ ...validElements });

    emptyElements[name] = empty;
    setEmptyElements({ ...emptyElements });
  };

  const [elements] = useState({
    number: (
      <CardNumberElement
        style={style}
        onChange={(e) => onElementChange("number", e)}
      />
    ),
    expiry: (
      <CardExpiryElement
        style={style}
        onChange={(e) => onElementChange("expiry", e)}
      />
    ),
    cvc: (
      <CardCvcElement
        style={style}
        onChange={(e) => onElementChange("cvc", e)}
      />
    ),
  });

  const onSubmit = async (billingAddress = shippingAddress) => {
    if (!errors["number"] && emptyElements["number"]) {
      setElementError("number", "You must enter the card number.");
    }

    if (!errors["expiry"] && emptyElements["expiry"]) {
      setElementError("expiry", "You must enter the expiry date.");
    }

    if (!errors["cvc"] && emptyElements["cvc"]) {
      setElementError("cvc", "You must enter the CVC number date.");
    }

    if (
      !validElements["number"] ||
      !validElements["expiry"] ||
      !validElements["cvc"]
    ) {
      return;
    }

    setSubmitting(true);

    // payment method data to pass to stripe
    const stripePaymentMethod = {
      card: props.elements.getElement("cardNumber"),
      billing_details: AddressHelper.convertToStripeFormat(billingAddress),
    };

    // payment method data to pass to the server
    const extraData = {
      billing_address: billingAddress,
    };

    await processPayment("stripe_card", stripePaymentMethod, extraData);

    setSubmitting(false);
  };

  return (
    <>
      <img
        src="/assets/card-brands.png"
        style={{
          width: "100%",
          maxWidth: "200px",
          margin: "0 auto 16px auto",
          display: "block",
        }}
      />

      <div className="row">
        <div className="col-md-8">
          {elements.number}

          <div className="error">{errors.number}</div>
        </div>
        <div className="col-md-2">
          {elements.expiry}

          <div className="error">{errors.expiry}</div>
        </div>
        <div className="col-md-2">
          {elements.cvc}

          <div className="error">{errors.cvc}</div>
        </div>
      </div>

      <div className="checkbox">
        <label>
          <input
            type="checkbox"
            checked={sameAddress}
            onChange={(e) => setSameAddress(!sameAddress)}
          />
          Billing address is the same as shipping.
        </label>
      </div>

      {!sameAddress && (
        <>
          <h3 style={{ marginBottom: 0 }}>Billing Address</h3>

          <AddressForm
            showName
            showPhone
            address={shippingAddress}
            submitAction={onSubmit}
            submitLabel="Complete Purchase"
            successTitle={false}
          />
        </>
      )}

      {sameAddress && (
          <div className="action-row">
            <SubmitButton
              onClick={() => onSubmit()}
              label="Complete Purchase"
              isSubmitting={submitting}
            />
        </div>
      )}
    </>
  );
};

export default injectStripe(CardForm);
